import * as React from "react";
import { Building2, Target, TrendingUp, Magnet, Zap, ShieldCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const differentiators = [{
  title: "Recht auf Auskunft",
  description: "Sie haben das Recht, jederzeit eine Bestätigung darüber zu verlangen, ob wir personenbezogene Daten von Ihnen verarbeiten.",
  icon: Building2
}, {
  title: "Recht auf Berichtigung",
  description: "Sollten Ihre bei uns gespeicherten Daten unrichtig oder unvollständig sein, können Sie eine sofortige Korrektur verlangen.",
  icon: Target
}, {
  title: "Recht auf Löschung",
  description: "Unter bestimmten Voraussetzungen können Sie die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten fordern.",
  icon: TrendingUp
}, {
  title: "Recht auf Widerspruch",
  description: "Sie können der Verarbeitung Ihrer Daten aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit widersprechen.",
  icon: Magnet
}, {
  title: "Datenübertragbarkeit",
  description: "Sie haben das Recht, Daten, die wir automatisiert verarbeiten, in einem gängigen, maschinenlesbaren Format zu erhalten.",
  icon: Zap
}, {
  title: "Beschwerderecht",
  description: "Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer Daten durch uns zu beschweren.",
  icon: ShieldCheck
}];
export default function IhreRechte() {
  return <section data-section-id="261623" id="ihre-rechte" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />

      <div className="page-container relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <Badge variant="secondary" className="mb-6 bg-accent text-accent-foreground font-default">
            Datenschutz & Kontrolle
          </Badge>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-6">
            Ihre Rechte als Nutzer
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default">
            Transparenz ist uns wichtig. Hier finden Sie eine Übersicht Ihrer gesetzlichen Rechte gemäß der Datenschutz-Grundverordnung (DSGVO).
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {differentiators.map((item, i) => {
          const Icon = item.icon;
          return <Card key={i} data-index={i} className="group border-border shadow-md hover:shadow-lg transition-all duration-300 hover:border-primary/40 bg-card backdrop-blur-sm rounded-lg">
                <CardHeader className="gap-4">
                  <div className="size-12 rounded-lg bg-primary/5 flex items-center justify-center group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <Icon className="size-6 text-primary group-hover:text-primary-foreground transition-colors duration-300" />
                  </div>
                  <div className="space-y-2">
                    <CardTitle className="font-default text-xl text-foreground">
                      {item.title}
                    </CardTitle>
                    <CardDescription className="font-default text-base leading-relaxed text-muted-foreground">
                      {item.description}
                    </CardDescription>
                  </div>
                </CardHeader>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}